import { Views } from '@neos/app'
import { OpenModeType, PopupPosition } from '@neos/shared'

export const views: Views = {
  default: [
    {
      name: 'AssignPermissionToRolesListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AssignPermissionToRolesListUI/AssignPermissionToRolesListUI.vue'),
    },
    {
      name: 'AssignPermissionToRolesUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/AssignPermissionToRolesUI/AssignPermissionToRolesUI.vue'),
    },
    {
      name: 'CommunicationTemplatesUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CommunicationTemplatesUI/CommunicationTemplatesUI.vue'),
    },
    {
      name: 'CountryLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CountryLookupUI/CountryLookupUI.vue'),
    },
    {
      name: 'CountryUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CountryUI/CountryUI.vue'),
    },
    {
      name: 'CultureListUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CultureListUI/CultureListUI.vue'),
    },
    {
      name: 'CurrencyLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CurrencyLookupUI/CurrencyLookupUI.vue'),
    },
    {
      name: 'CurrencyUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CurrencyUI/CurrencyUI.vue'),
    },
    {
      name: 'CustomerProfilePaymentMethodUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomerProfilePaymentMethodUI/CustomerProfilePaymentMethodUI.vue'),
    },
    {
      name: 'CustomerProfileUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/CustomerProfileUI/CustomerProfileUI.vue'),
    },
    {
      name: 'DeveloperMenuUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DeveloperMenuUI/DeveloperMenuUI.vue'),
    },
    {
      name: 'DiscountUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/DiscountUI/DiscountUI.vue'),
    },
    {
      name: 'InvoicingSettingUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/InvoicingSettingUI/InvoicingSettingUI.vue'),
    },
    {
      name: 'KnownIanaTimeZoneUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/KnownIanaTimeZoneUI/KnownIanaTimeZoneUI.vue'),
    },
    {
      name: 'MunicipalityLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MunicipalityLookupUI/MunicipalityLookupUI.vue'),
    },
    {
      name: 'MunicipalityUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/MunicipalityUI/MunicipalityUI.vue'),
    },
    {
      name: 'NeosBaseUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/NeosBaseUI/NeosBaseUI.vue'),
    },
    {
      name: 'PaymentMethodUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PaymentMethodUI/PaymentMethodUI.vue'),
    },
    {
      name: 'PaymentTermUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PaymentTermUI/PaymentTermUI.vue'),
    },
    {
      name: 'PermissionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PermissionUI/PermissionUI.vue'),
    },
    {
      name: 'PriceListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PriceListUI/PriceListUI.vue'),
    },
    {
      name: 'PrintingSettingUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/PrintingSettingUI/PrintingSettingUI.vue'),
    },
    {
      name: 'ProductCategoryUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ProductCategoryUI/ProductCategoryUI.vue'),
    },
    {
      name: 'ProductCategoryUnitUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ProductCategoryUnitUI/ProductCategoryUnitUI.vue'),
    },
    {
      name: 'ProvinceStateLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ProvinceStateLookupUI/ProvinceStateLookupUI.vue'),
    },
    {
      name: 'ProvinceStateUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/ProvinceStateUI/ProvinceStateUI.vue'),
    },
    {
      name: 'SalesTaxApplicableDateDetailUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SalesTaxApplicableDateDetailUI/SalesTaxApplicableDateDetailUI.vue'),
    },
    {
      name: 'SalesTaxApplicableDateUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SalesTaxApplicableDateUI/SalesTaxApplicableDateUI.vue'),
    },
    {
      name: 'SalesTaxApplicableUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SalesTaxApplicableUI/SalesTaxApplicableUI.vue'),
    },
    {
      name: 'SalesTaxExceptionCollectedUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SalesTaxExceptionCollectedUI/SalesTaxExceptionCollectedUI.vue'),
    },
    {
      name: 'SalesTaxExceptionNotCollectedUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SalesTaxExceptionNotCollectedUI/SalesTaxExceptionNotCollectedUI.vue'),
    },
    {
      name: 'SalesTaxExceptionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SalesTaxExceptionUI/SalesTaxExceptionUI.vue'),
    },
    {
      name: 'SalesTaxRateUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SalesTaxRateUI/SalesTaxRateUI.vue'),
    },
    {
      name: 'SalesTaxUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/SalesTaxUI/SalesTaxUI.vue'),
    },
    {
      name: 'UnitTypeLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UnitTypeLookupUI/UnitTypeLookupUI.vue'),
    },
    {
      name: 'UnitTypeUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UnitTypeUI/UnitTypeUI.vue'),
    },
    {
      name: 'UnitUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UnitUI/UnitUI.vue'),
    },
    {
      name: 'UserAccountAvailableUI',
      openMode: OpenModeType.popupFullSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountAvailableUI/UserAccountAvailableUI.vue'),
    },
    {
      name: 'UserAccountListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountListUI/UserAccountListUI.vue'),
    },
    {
      name: 'UserAccountLookupUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountLookupUI/UserAccountLookupUI.vue'),
    },
    {
      name: 'UserAccountUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUI/UserAccountUI.vue'),
    },
    {
      name: 'UserAccountUserRoleEntityUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleEntityUI/UserAccountUserRoleEntityUI.vue'),
    },
    {
      name: 'UserAccountUserRoleMultiClusterUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleMultiClusterUI/UserAccountUserRoleMultiClusterUI.vue'),
    },
    {
      name: 'UserAccountUserRoleUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserAccountUserRoleUI/UserAccountUserRoleUI.vue'),
    },
    {
      name: 'UserPermissionUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserPermissionUI/UserPermissionUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsJobUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsJobUI/UserReportPrintSettingsJobUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsListUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsListUI/UserReportPrintSettingsListUI.vue'),
    },
    {
      name: 'UserReportPrintSettingsUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserReportPrintSettingsUI/UserReportPrintSettingsUI.vue'),
    },
    {
      name: 'UserRoleAssignmentUI',
      openMode: OpenModeType.popupAutoSize,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserRoleAssignmentUI/UserRoleAssignmentUI.vue'),
    },
    {
      name: 'UserSettingsUI',
      openMode: OpenModeType.newFrame,
      popupPosition: PopupPosition.center,
      component: () => import('./views/UserSettingsUI/UserSettingsUI.vue'),
    },
  ],
}
